import styled, { css } from 'styled-components';
import tw from 'twin.macro';

export const OmegaMultiSelectStyledComponent = styled.div`
  ${tw`w-full`}
  ${(props) =>
    props.error &&
    css`
      .css-1s2u09g-control {
        ${tw`border-red-400 border-1`}
      }
      .css-14el2xx-placeholder {
        color: #991b1b !important;
      }
    `}
`;
